
import React from 'react'
import { mdx } from '@mdx-js/react'
export const readingTime = {"text":"1 min read","minutes":0.45,"time":27000,"words":90}
/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <div className="column">
      <h2 {...{
        "id": "the-portic-program"
      }}>{`The PORTIC Program`}</h2>
      <p>{`The PORTIC research program (ANR-18-CE38–0010) aims at crossing french navigation and foreign trade data at the eve of the French Revolution, in order to understand ongoing commercial dynamics. To do so, it offers data visualization and querying interfaces adapted to various audiences and interests.`}</p>
      <p><a parentName="p" {...{
          "href": "https://anr.portic.fr/"
        }}>{`Learn more about the PORTIC program`}</a></p>
    </div>
    <div className="column">
      <p>{`The contents of this website are published under `}<a parentName="p" {...{
          "href": "https://creativecommons.org/licenses/by-nc-sa/3.0/fr/"
        }}>{`creative commons license CC-BY-SA-NC`}</a>{`.`}</p>
      <p>{`The source code of this website is published under `}<a parentName="p" {...{
          "href": "https://www.gnu.org/licenses/agpl-3.0.fr.html"
        }}>{`AGPL-3.0 license`}</a>{`.`}</p>
      <p><a parentName="p" {...{
          "href": "https://github.com/medialab/portic-storymaps-2021/"
        }}>{`Access the source code of this website`}</a></p>
    </div>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;
export const tableOfContents = (components={}) => [
  {
    id: "the-portic-program",
    level: 2,
    title: "The PORTIC Program",
    children: [
        
      ]
  }
]

export const frontMatter = {}

